import { formatDateObjectToString, formatDateStringToObject, offsetDateToEst } from 'syf-js-utilities/formats';
import getTodaysTimeOffset from './getTodaysTimeOffset';
export const getEstDateObject = (dateObjectOrString) => {
    const dateObject = typeof dateObjectOrString === 'string'
        ? new Date(formatDateStringToObject(dateObjectOrString).getTime() +
            getTodaysTimeOffset())
        : dateObjectOrString;
    return offsetDateToEst(dateObject);
};
export const getEstDateString = (dateObjectOrString) => {
    const estDateObject = getEstDateObject(dateObjectOrString);
    return formatDateObjectToString(estDateObject);
};
